import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import actionTypes from 'constants/actionTypes';

import Button from 'modules/_shared/components/Buttons';

import { useAddFolderModal } from '../context/AddFolderModalContext';

const AddFolderModalFooter: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useAddFolderModal();

  const buttonDisabled = !data.name;

  const buttonLabel =
    data.modalActionType === actionTypes.ADD ? t('Create') : t('Update');

  return (
    <Modal.Footer>
      <Button
        disabled={buttonDisabled}
        onClick={actions.handleSaveFolder}
        lgSize
      >
        {buttonLabel}
      </Button>
    </Modal.Footer>
  );
};

export default AddFolderModalFooter;
